import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import Seo from "@/components/Seo";
import { Logo } from "@/components/Logo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0C] p-5">
      <Seo title="Admin Login" path="/admin/login" />
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Logo variant="stacked" /></div>
        <form onSubmit={submit} className="rounded-2xl border border-[#22222c] bg-[#101017] p-8" data-testid="admin-login-form" noValidate>
          <div className="mb-6 flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-amber-400/10 text-amber-400"><Lock className="h-5 w-5" /></div>
            <div>
              <h1 className="font-display text-xl font-bold uppercase text-white">Admin Login</h1>
              <p className="text-xs text-neutral-500">Quote request dashboard</p>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <Label className="mb-1.5 block text-sm text-neutral-200">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-[#0f0f15] border-[#2a2a34] text-white" data-testid="admin-email" />
            </div>
            <div>
              <Label className="mb-1.5 block text-sm text-neutral-200">Password</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-[#0f0f15] border-[#2a2a34] text-white" data-testid="admin-password" />
            </div>
          </div>
          {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-amber-400 py-3.5 font-bold uppercase tracking-wide text-[#0A0A0C] hover:bg-amber-300 disabled:opacity-60" data-testid="admin-login-submit">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
